import { memo, useMemo } from "react";
import { NormalizedDescriptionInfo } from "@common/types/normalizedDescription";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { TransactionRuleConditions } from "@components/transactionRules/TransactionRuleConditions";
import { useNormalizedDescriptions } from "@hooks/useNormalizedDescriptions";
import { RuleHistoryListRow } from "../views/ruleHistoryListViewConfig";
import styles from "./RuleHistorySummaryCell.module.scss";

export const RuleHistorySummaryCell = memo(
    ({ row }: { row: { original: RuleHistoryListRow } }) => {
        const { ruleResourceId, conditions, conditionTexts } = row.original;
        const { data } = useNormalizedDescriptions();
        const normalizedDescriptions = useMemo<NormalizedDescriptionInfo[]>(
            () =>
                (data?.normalizedDescriptions ?? []).map((desc) => ({
                    id: desc.normalizedDescriptionId,
                    normalizedDescription: desc.normalizedDescription,
                })),
            [data],
        );

        return (
            <ViewTableCell className="conditions">
                {conditions.length > 0 && (
                    <div className={styles.visualList}>
                        <TransactionRuleConditions
                            rule={{ id: ruleResourceId, conditions }}
                            counterparties={[]}
                            normalizedDescriptions={normalizedDescriptions}
                        />
                    </div>
                )}
                {conditions.length === 0 && conditionTexts.length > 0 && (
                    <div className={styles.visualList}>
                        {conditionTexts.map((text, i) => (
                            <div key={i} className={styles.conditionText}>
                                {text}
                            </div>
                        ))}
                    </div>
                )}
            </ViewTableCell>
        );
    },
);
RuleHistorySummaryCell.displayName = "RuleHistorySummaryCell";
